import React from 'react';
import PropTypes from 'prop-types';
import { IfScope } from '@playbookux/playbook-web-core';
import {
  InProgressContainer,
  Content,
  ClockImage,
  Message,
  UploadMessage,
  List,
  ListItem,
  ButtonContainer,
} from './styles';
import { PROJECT_TYPES_ENUMS } from '../../../../core/constants/projects';
import UploadButton from '../../../components/upload-button';
import { useUserScope } from '../../../../core/hooks';

const EmptyResult = (props) => {
  const {
    testType,
    onUploadClick,
  } = props;

  const scope = useUserScope();

  if (testType === PROJECT_TYPES_ENUMS.UPLOAD) {
    return (
      <InProgressContainer>
        <Content>
          <ClockImage src="/images/clock.png" />

          <IfScope shareProject scope={scope}>
            <UploadMessage as="h3">
              You haven&apos;t uploaded any research yet
            </UploadMessage>
          </IfScope>

          <IfScope user scope={scope}>
            <UploadMessage as="h3">
              You haven&apos;t uploaded any research yet.
              <br />
              Click the &quot;Upload&quot; button below to get started.
            </UploadMessage>

            <ButtonContainer>
              <UploadButton text="Upload" handleOpenUploader={onUploadClick} />
            </ButtonContainer>
          </IfScope>
        </Content>
      </InProgressContainer>
    );
  }
  if (
    testType === PROJECT_TYPES_ENUMS.CARD_SORT
    || testType === PROJECT_TYPES_ENUMS.TREE_TEST
    || testType === PROJECT_TYPES_ENUMS.SURVEY
  ) {
    return (
      <InProgressContainer>
        <Content>
          <ClockImage src="/images/clock.png" />
          <Message as="h3">
            Your study is in progress! What&apos;s next?
          </Message>

          <List>
            <ListItem>
              Expect an email from us when the first and last participant
              completes their session
            </ListItem>
          </List>
        </Content>
      </InProgressContainer>
    );
  }
  return (
    <InProgressContainer>
      <Content>
        <ClockImage src="/images/clock.png" />
        <Message as="h3">
          Your study is in progress! What&apos;s next?
        </Message>

        {testType === PROJECT_TYPES_ENUMS.MODERATED && (
          <List>
            <ListItem>
              If you haven’t done so already, please set up your schedule.
            </ListItem>
            <ListItem>
              When a participant books a time, their information and a meeting
              link will appear on the Schedule tab. You will also receive a confirmation
              email and a calendar invite.
            </ListItem>
            <ListItem>
              After each session, the video will be uploaded, transcribed and stored on the
              Participants tab. It may take a while to process your video, so please be patient.
            </ListItem>
          </List>
        )}

        {testType === PROJECT_TYPES_ENUMS.UNMODERATED && (
          <>
            <List>
              <ListItem>
                Expect an email from us when the first participant completes
                their session and the video is uploaded.
              </ListItem>
              <ListItem>
                Once all videos are received, the analytics and quotes tabs will be populated.
              </ListItem>
            </List>
          </>
        )}
      </Content>
    </InProgressContainer>
  );
};

EmptyResult.propTypes = {
  testType: PropTypes.string.isRequired,
  onUploadClick: PropTypes.func,
};

EmptyResult.defaultProps = {
  onUploadClick: () => { },
};

export default EmptyResult;
